module.exports = __webpack_public_path__ + "img/driver-risk-black.48c9c7bf.png";